import {  Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../utils/AuthContext";
import Sidebar from "../components/sidebar-menu/Sidebar";

export default function PrivateLayout() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        try {
            await logout();
            navigate('/', { replace:true });
        } catch (error) {
            console.error('Error logging out', error);
        }
    };

    return (
        <div className='flex ml-0 md:ml-64 p-4 pt-16 md:pt-4 bg-gray-50 min-h-screen'>
            <Sidebar user={user} handleLogout={handleLogout}  />

            <main className='flex-1 p-6 bg-gray-100'>
                <Outlet />
            </main>
        </div>
    )
}